export const GET_PENDING_FINANCIAL_REQUESTS = `
  query GetPendingFinancialRequests($where: report_financial_requests_bool_exp = {}) {
    report_financial_requests(
      where: { _and: [{ status: { _eq: "pending" } }, $where] }
      order_by: { requested_at: desc }
    ) {
      id
      job_id
      report_id
      requested_at
      requested_by_user {
        id
        first_name
        last_name
      }
      job {
        id
        job_title
        firm_short_name
        project_number
        job_reports
        contract {
          id
          firm {
            id
            firm_name
          }
        }
      }
    }
  }
`;
